import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { BlockSpiderChartComponent } from '@app/components/blocks/block-spiderChart/block-spiderChart.component';
import { SpiderChartModule } from '@app/components/spiderChart/spiderChart.module';

@NgModule({
  imports: [CommonModule, SharedModule, SpiderChartModule],
  declarations: [BlockSpiderChartComponent],
  exports: [BlockSpiderChartComponent],
})
export class BlockSpiderChartModule {}
